import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserRoles} from "../../../../../enums/general-enums";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {AuthenticationHelperService} from "../../../../../services/helpers/authentication-helper.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tl-single-plan',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    NgClass,
    TranslateModule,
    DatePipe
  ],
  templateUrl: './single-plan.component.html',
})
export class SinglePlanComponent {
  @Input() plan: any;
  @Input() currentPlan: any;
  @Output() clickToSubscribeOnPlan: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickToCancelSubscription: EventEmitter<any> = new EventEmitter<any>();
  protected readonly UserRoles = UserRoles;

  constructor(public authHelperService: AuthenticationHelperService) {}


  handleSubscription(plan: any): void {
    if (this.currentPlan?.plan === plan.planId) {
      this.clickToCancelSubscription.emit(plan);
    } else {
      this.clickToSubscribeOnPlan.emit(plan);
    }
  }
}
